export const GlobalFunction = {
    checkPermission: (permission) => {
        var all_permissions = JSON.parse(localStorage.getItem('userRoles'))
              all_permissions = all_permissions[0].permissions
              if (all_permissions.some(e => e.name === permission)) {
                return true
              }
              else{
                  return false
              }
     }
 }